import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";

const DependenciesDialog = ({ visible, onHide, eligibleFields, onSave }) => {
  const [deps, setDeps] = useState([]);

  const addDependency = () => {
    setDeps([...deps, { Parent: null, Child: null }]);
  };

  const removeDependency = (idx) => {
    setDeps(deps.filter((_, i) => i !== idx));
  };

  const handleChange = (idx, type, value) => {
    const updated = [...deps];
    updated[idx][type] = value;
    setDeps(updated);
  };

  const handleSave = () => {
    const depsConf = deps
      .filter((dep) => dep.Parent && dep.Child)
      .map((dep) => ({
        Parent: {
          currentFieldKey: dep.Parent.key,
          formId: dep.Parent.importedFromForm.formid,
          importFieldKey: dep.Parent.importedFromForm.fieldname,
        },
        Child: {
          currentFieldKey: dep.Child.key,
          formId: dep.Child.importedFromForm.formid,
          importFieldKey: dep.Child.importedFromForm.fieldname,
        },
      }));
    onSave(depsConf);
  };

  return (
    <Dialog
      header="Configure Field Dependencies"
      visible={visible}
      style={{ width: "80vw", height: "80vh" }}
      onHide={onHide}
      modal
      footer={
        <div>
          <Button
            label="Save"
            icon="pi pi-check"
            style={{
              backgroundColor: "#0D2E4D",
              color: "#fff",
              border: "none",
              marginRight: 8,
              minWidth: 100,
            }}
            onClick={handleSave}
          />
        </div>
      }
    >
      <div style={{ padding: "10px 0" }}>
        <div
          style={{ display: "flex", alignItems: "center", marginBottom: 20 }}
        >
          <span style={{ fontWeight: "bold", fontSize: 18, color: "#0D2E4D" }}>
            Add Parent/Child Field Dependencies
          </span>
          <Button
            icon="pi pi-plus"
            label="Add Dependency"
            className="p-button"
            onClick={addDependency}
            style={{
              backgroundColor: "#e29b45",
              color: "#fff",
              border: "none",
              marginLeft: "auto",
              minWidth: 160,
            }}
          />
        </div>
        {deps.length === 0 && (
          <div style={{ textAlign: "center", color: "#888", marginBottom: 20 }}>
            No dependencies added yet.
          </div>
        )}
        {deps.map((dep, idx) => (
          <div
            key={idx}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 12,
              marginBottom: 16,
              background: "#f7f7f7",
              padding: "12px 10px",
              borderRadius: 8,
              boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
            }}
          >
            <Dropdown
              value={dep.Parent}
              options={eligibleFields}
              optionLabel="key"
              placeholder="Select Parent"
              style={{ width: "80%", height: "80%" }}
              onChange={(e) => handleChange(idx, "Parent", e.value)}
              className="p-inputtext"
            />
            <span style={{ fontWeight: "bold", color: "#e29b45" }}>→</span>
            <Dropdown
              value={dep.Child}
              options={eligibleFields}
              optionLabel="key"
              placeholder="Select Child"
              style={{ width: "40%" }}
              onChange={(e) => handleChange(idx, "Child", e.value)}
              className="p-inputtext"
            />
            <Button
              icon="pi pi-minus"
              className="p-button"
              onClick={() => removeDependency(idx)}
              style={{
                backgroundColor: "#e29b45",
                color: "#fff",
                border: "none",
                minWidth: 40,
                marginLeft: 8,
              }}
              tooltip="Remove"
              tooltipOptions={{ position: "top" }}
            />
          </div>
        ))}
      </div>
    </Dialog>
  );
};

export default DependenciesDialog;
